import React, { useContext, useEffect, useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import FocusedLocalCallContext from 'flow/contexts/call-item-size-context';
import MeetingCallItem from 'flow/components/meeting/call/MeetingCallItem';
import MeetingVideoCanvas from 'flow/components/meeting/MeetingVideoCanvas';
import {
    getOwnActiveCalls,
    getFocusedLocalCallId,
} from 'flow/selectors/call-selectors';
import {
    selectActiveMeetingViewIsFullscreen,
    selectActiveMeetingCode,
} from 'flow/selectors/meeting-selectors';

const Meeting: React.FC = () => {
    const hasActiveCall = useAppSelector(
        (state) => getOwnActiveCalls(state).size > 0,
    );
    const isFullscreenView = useAppSelector(
        selectActiveMeetingViewIsFullscreen,
    );
    const meetingCode = useAppSelector(selectActiveMeetingCode);
    const focusedCallId = useAppSelector(getFocusedLocalCallId);

    const focusedLocalCallId = useContext(FocusedLocalCallContext);
    const [focusedCallHungUp, setFocusedCallHungUp] = useState<boolean>(false);

    useEffect(() => {
        if (
            focusedLocalCallId !== meetingCode &&
            focusedCallId === meetingCode
        ) {
            setFocusedCallHungUp(true);
        } else {
            setFocusedCallHungUp(false);
        }
    }, [focusedLocalCallId, meetingCode, focusedCallId]);

    if ((hasActiveCall || focusedCallHungUp) && !isFullscreenView) {
        return <MeetingCallItem focusedCallHungUp={focusedCallHungUp} />;
    } else {
        return <MeetingVideoCanvas />;
    }
};

export default Meeting;
